// src/components/wall/IronbearsRealtimeComponent.jsx
import React from "react";
import { motion } from "framer-motion";
import { SparklesCore } from "../../../../shared/animations/sparkles/soarklesCore";

// Parent drives the stagger of its children (left -> right)
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      delayChildren: 0.25,
      staggerChildren: 0.14,
      staggerDirection: 1, // left-to-right order
      when: "beforeChildren",
      ease: "easeOut",
    },
  },
};

// Each row: slide from left, fade in, un-blur
const itemVariants = {
  hidden: { opacity: 0, x: -40, filter: "blur(4px)" },
  visible: {
    opacity: 1,
    x: 0,
    filter: "blur(0px)",
    transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
  },
};

// Small presentational component for one banner row
function BannerRow({
  symbol,
  percent,
  time,
  name,
  avatar = "/avatar/avatar-default.webp",
}) {
  return (
    <motion.div
      variants={itemVariants}
      className="team-banner-container w-[700px] h-[70px] flex items-center justify-center relative will-change-transform transform-gpu"
      layout
    >
      <img
        style={{ dropShadow: "0px 4px 4px 0px #00000040" }}
        className="w-[70px] h-auto absolute right-[80px] top-[-30px] z-[2]"
        src={avatar}
        alt="avatar"
      />
      <img
        className="w-[600px] absolute z-[1]"
        src="/teams/ironbears-baner.svg"
        alt="banner"
      />
      <div className="text-container relative z-[3] flex items-center justify-end w-full gap-[52px] mr-[194px] mt-[16px]">
        <span className="text-[#FFFFFF] text-[14px] font-bold">{symbol}</span>
        <span className="text-[#40BF6A] text-[14px] font-bold">{percent}</span>
        <span className="text-[#FFFFFF] text-[14px] font-bold">{time}</span>
        <span className="text-[#FFFFFF] text-[12px] font-normal">{name}</span>
      </div>
    </motion.div>
  );
}

export function IronbearsRealtimeComponent() {
  // Your rows (replace with live data later). The stagger will follow this order.
  const rows = [
    {
      symbol: "XAUUSDT",
      percent: "25%",
      time: "08:20-20:20",
      name: "نام و نام خوانوادگی",
    },
    {
      symbol: "BTCUSDT",
      percent: "18%",
      time: "10:10-12:30",
      name: "نام و نام خوانوادگی",
    },
    {
      symbol: "ETHUSDT",
      percent: "12%",
      time: "12:45-16:00",
      name: "نام و نام خوانوادگی",
    },
    {
      symbol: "EURUSD",
      percent: "9%",
      time: "14:00-19:30",
      name: "نام و نام خوانوادگی",
    },
    {
      symbol: "US100",
      percent: "7%",
      time: "09:00-17:00",
      name: "نام و نام خوانوادگی",
    },
  ];

  return (
    <div className="w-full flex h-full items-center justify-center flex-col gap-[50px]">
      <SparklesCore
        id="tsparticlesfullpage"
        background="transparent"
        minSize={0.6}
        maxSize={1.4}
        particleDensity={30}
        className="w-full h-full absolute top-[0] left-[50%] translate-x-[-50%] overflow-hidden"
        particleColor="#E8232C"
      />

      {/* Header */}
      <div>
        <div className="w-full flex items-center justify-center flex-col gap-3">
          <img
            className="w-[192px]"
            src="/teams/ironbears-logo.webp"
            alt="Ironbears"
          />
          <h2
            style={{ fontFamily: "Etemad" }}
            className="text-[#E5F7FF] font-bold text-[26px]"
          >
            IIRON BEARS
          </h2>
        </div>

        {/* Light streaks */}
        <div className="relative mt-2 w-[40rem]">
          <div className="absolute inset-x-20 top-0 h-[3px] w-3/4 bg-gradient-to-r from-transparent via-white/70 to-transparent blur-md" />
          <div className="absolute inset-x-20 top-0 h-px w-3/4 bg-gradient-to-r from-transparent via-white to-transparent drop-shadow-[0_0_8px_#ffffff]" />
          <div className="absolute inset-x-60 top-0 h-[6px] w-1/4 bg-gradient-to-r from-transparent via-white/80 to-transparent blur-md" />
          <div className="absolute inset-x-60 top-0 h-px w-1/4 bg-gradient-to-r from-transparent via-white to-transparent drop-shadow-[0_0_10px_#ffffff]" />
          <div className="absolute inset-x-44 top-0 h-[2px] w-2/4 bg-gradient-to-r from-transparent via-sky-100/60 to-transparent blur-[2px]" />
          <div className="pointer-events-none absolute inset-0 h-full w-full [mask-image:radial-gradient(350px_200px_at_top,transparent_20%,white)]" />
        </div>
      </div>

      {/* Rows with staggered entrance (left -> right) */}
      <motion.div
        className="flex flex-col items-center justify-start gap-[42px]"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {rows.map((r, i) => (
          <BannerRow key={i} {...r} />
        ))}
      </motion.div>
    </div>
  );
}

export default IronbearsRealtimeComponent;
